import {
  CourseStatus,
  SECTION_NON_REPORTABLE_COURSE_LEVELS,
} from '../../../interfaces/commons';
import { CourseResponse } from '../../../interfaces/courses';
import { IUser } from '../../../interfaces/login';
import { isDelegato } from '../../../libs/utils/auth';

export const isCourseVisibleInReportList = (
  course: CourseResponse,
  profile: Partial<IUser> | undefined
) => {
  const isDelegate = isDelegato(profile);
  const isStatusReportable = isDelegate
    ? course.attributes.status === CourseStatus.PUBLISHED
    : course.attributes.status === CourseStatus.FINAL_BALANCE_DELEGATION ||
      course.attributes.status === CourseStatus.PUBLISHED;
  const isLevelReportable =
    !isDelegate ||
    !course.attributes.level ||
    !SECTION_NON_REPORTABLE_COURSE_LEVELS.includes(course.attributes.level);

  return isStatusReportable && isLevelReportable;
};

export const getCoursesVisibleInReportList = (
  courses: CourseResponse[],
  profile: Partial<IUser> | undefined
) => courses.filter((course) => isCourseVisibleInReportList(course, profile));
